export const environment = {
    production: false,
    urlAPI: 'https://dev-api-rm.lnkgs.es/api/',
    urlApp: 'https://dev-rm.lnkgs.es/',
    azureAd: {
      clientId: '140c349b-5de0-4b19-b430-9587c89ba84c',
      tenantId: '05c15b0f-cfe8-4d7c-a534-1d67a17d8c18',
      authority: 'https://login.microsoftonline.com/05c15b0f-cfe8-4d7c-a534-1d67a17d8c18',
      redirectUri: 'https://dev-rm.lnkgs.es/',
      postLogoutRedirectUri: 'https://dev-rm.lnkgs.es/',
      apiScope: 'api://ca27f5e2-fb70-4345-ba12-ba0a919867c9/.default',
    },
    blobPublic: 'https://blobrenaultmanager.blob.core.windows.net/dev-renault-manager-public/',
  };
  